/** @format */

import React from 'react';

/**
 * Mapper HOC for input errors
 * @param ComponentContainer
 * @returns {ErrorDisplayHandler}
 */
export default ComponentContainer => {
    return class HandleInputError extends React.Component {
        constructor(props) {
            super(props);
        }

        render() {
            const {error, errorPath, ...props} = this.props;
            props['data-ref-name'] = errorPath; // This ensures I have something to target for tests
            return <ComponentContainer {...props} />;
        }
    };
};
